<template>
        <div class="mod-demo__news" style="background-color: #ffffff">
            <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
                <el-form-item>
                    <el-input v-model="dataForm.name" placeholder="请输入姓名或联系电话" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button @click="getDataList()">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="addOrUpdateHandle()">添加</el-button>
                </el-form-item>
            </el-form>
            <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle"
                      @sort-change="dataListSortChangeHandle" style="width: 100%">
                <el-table-column prop="id" label="编号" header-align="center" align="center"></el-table-column>
                <el-table-column prop="name" label="机构名称" header-align="center" align="center"></el-table-column>
                <el-table-column prop="lxr" label="姓名" header-align="center" align="center"></el-table-column>
                <el-table-column prop="mobile" label="联系电话" header-align="center" align="center"></el-table-column>
                <el-table-column prop="userName" label="账号" header-align="center" align="center"></el-table-column>
                <el-table-column label="操作" fixed="right" header-align="center" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small"
                                   @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
                        <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination :current-page="page" :page-sizes="[10, 20, 50, 100]" :page-size="limit" :total="total"
                           layout="total, sizes, prev, pager, next, jumper" @size-change="pageSizeChangeHandle"
                           @current-change="pageCurrentChangeHandle">
            </el-pagination>
            <!-- 弹窗, 新增 / 修改 -->
            <add-or-update  v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
        </div>
</template>

<script>
    import mixinViewModule from "@/mixins/view-module";
    import AddOrUpdate from "./add-or-update";
    export default {
        mixins: [mixinViewModule],
        components: {
            AddOrUpdate,
        },
        data() {
            return {
                mixinViewModuleOptions: {
                    getDataListURL: "/account/accountList",
                    getDataListIsPage: true,
                    deleteURL: "/account/delete",
                    createdIsNeed: true,
                },
                dataForm: {
                    name: "",
                    area: JSON.parse(localStorage.getItem('org')).area || ''
                },
            };
        },
        watch: {

        },
        methods: {
            stopHandle(id) {
                this.$confirm('确定进行停用操作？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$http.get(
                        `/account/stop/${id}`,
                    ).then(({ data: res }) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: '操作成功',
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.query()
                            }
                        })
                    }).catch(() => {})
                }).catch(() => {})
            }
        },
    };
</script>
